import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import {
  GridActionsCellItem,
  GridColDef,
  GridRowParams,
} from '@mui/x-data-grid-pro';
import { useMemo } from 'react';
import { IcdCode } from '../../types';
import { formatDate } from '../../utils/date-helper';

interface UseIcdCodeColumnsProps {
  onEdit: (row: IcdCode) => void;
  onDelete: (row: IcdCode) => void;
  canWrite: boolean;
}

export const useIcdCodeColumns = ({
  onEdit,
  onDelete,
  canWrite,
}: UseIcdCodeColumnsProps): GridColDef[] =>
  useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        width: 70,
      },
      {
        field: 'universalCode',
        headerName: 'Universal Code',
        flex: 0.8,
        minWidth: 130,
      },
      {
        field: 'rightCode',
        headerName: 'Right Code',
        flex: 0.8,
        minWidth: 120,
        valueFormatter: (params): string => params.value ?? '--',
      },
      {
        field: 'leftCode',
        headerName: 'Left Code',
        flex: 0.8,
        minWidth: 120,
        valueFormatter: (params): string => params.value ?? '--',
      },
      {
        field: 'indication',
        headerName: 'Indication',
        flex: 1,
        minWidth: 140,
      },
      {
        field: 'startDate',
        headerName: 'Start Date',
        flex: 0.8,
        minWidth: 120,
        valueFormatter: (params): string => formatDate(params.value),
      },
      {
        field: 'endDate',
        headerName: 'End Date',
        flex: 0.8,
        minWidth: 120,
        valueFormatter: (params): string => formatDate(params.value),
      },
      ...(canWrite
        ? [
            {
              field: 'actions',
              headerName: 'Actions',
              type: 'actions',
              width: 100,
              getActions: (params: GridRowParams<IcdCode>): JSX.Element[] => [
                <GridActionsCellItem
                  key={`edit-${params.id}`}
                  icon={<EditIcon />}
                  label="Edit"
                  onClick={(): void => onEdit(params.row)}
                />,
                <GridActionsCellItem
                  key={`delete-${params.id}`}
                  icon={<DeleteOutlineIcon />}
                  label="Delete"
                  onClick={(): void => onDelete(params.row)}
                />,
              ],
            },
          ]
        : []),
    ],
    [onEdit, onDelete, canWrite],
  );
